// Shared school crest thumbnail. Renders the logo when present, otherwise a
// color-filled initial-letter tile using the school's primary_color (or a
// muted fallback). Keep all crest rendering going through this so every
// reference surface looks identical.

interface SchoolCrestProps {
  name: string;
  logoUrl?: string | null;
  primaryColor?: string | null;
  /** Edge size in pixels. Defaults to 28. */
  size?: number;
  className?: string;
}

export function SchoolCrest({ name, logoUrl, primaryColor, size = 28, className = "" }: SchoolCrestProps) {
  const dim = { width: size, height: size };
  const radius = Math.max(2, Math.round(size / 8));
  const baseClass = `shrink-0 object-contain ${className}`;

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt=""
        style={{ ...dim, borderRadius: radius }}
        className={baseClass}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      style={{
        ...dim,
        borderRadius: radius,
        background: primaryColor ?? "var(--color-muted-foreground)",
        fontSize: Math.max(9, Math.round(size * 0.45)),
      }}
      className={`inline-flex items-center justify-center font-bold text-white ${className}`}
    >
      {(name?.charAt(0) ?? "?").toUpperCase()}
    </span>
  );
}
